import { ResolveFn } from '@angular/router';
import {inject} from '@angular/core';
import {RenderStrategy} from '../../enums/render-strategy';
import {StoryService} from '../story.service';
import {CategoryService} from '../category.service';

export const storyResolver: ResolveFn<Promise<void> | Promise<[void, void]>> = (activatedRouteSnapshot) => {
  const slugParam = activatedRouteSnapshot.paramMap.get('slug');
  if (!slugParam) {
    return Promise.resolve();
  }
  return Promise.all([
    inject(CategoryService).resolveIndex(RenderStrategy.PREFER_SERVER),
    inject(StoryService).resolveBySlug(slugParam, RenderStrategy.PREFER_SERVER)
  ]);
};
